import React from 'react';
import PasswordForgetForm from './PasswordForgetForm/PasswordForgetForm.js';

const passwordForget = props => (
  <React.Fragment>
    <h2 style={{ textAlign: 'center' }}>Password Forget</h2>
    <PasswordForgetForm />
  </React.Fragment>
);

export default passwordForget;



// WEBPACK FOOTER //
// ./src/components/PasswordForget/PasswordForget.js